import { render, staticRenderFns } from "./FormularioTransferir.vue?vue&type=template&id=1e23e7ba"
import script from "./FormularioTransferir.vue?vue&type=script&lang=js"
export * from "./FormularioTransferir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports